module.exports = __webpack_public_path__ + "static/img/resume.b6258c5.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/resume.png
// module id = 9Yle
// module chunks = 1